import axios from 'axios';
import Env from '~/env';
import { bannersToHomeBanners } from '~/mappers/Home/banners';

const api = axios.create({
  baseURL: Env.BANNER_URL,
  headers: {
    app: Env.BANNER_API_APP,
    secret: Env.BANNER_API_SECRET,
  },
});

const getBannersFromPlatform = async (type: 'mobile' | 'web') => {
  try {
    const { data } = await api.get<Banner.Root>(
      `/campaigns/marisa-servicos-${type}`
    );

    return bannersToHomeBanners(data);
  } catch {
    return null;
  }
};

export async function GetBannersUseCase(): Promise<Banner.Platform> {
  try {
    const [web, mobile] = await Promise.all([
      getBannersFromPlatform('web'),
      getBannersFromPlatform('mobile'),
    ]);

    return {
      web,
      mobile,
    };
  } catch {
    return {
      web: null,
      mobile: null,
    };
  }
}
